import { useState } from '#app'
import { readonly } from 'vue'

export function useTicketsEnabled() {
    const ticketsEnabled = useState('ticketsEnabled', () => true)
    return readonly(ticketsEnabled)
}
